import { scenarioQuestionTypesEnum } from "helpers/enums";
import { enumLabel } from "helpers/system";
import React from "react";

const ShowScenarioAnswerOption = ({ text, nextQuestionId, questionOptions, scenarioQuestion, externalData }) => {
    return (
        <tr>
            <td>{text}</td>
            <td>{externalData?.propertyName || "—"}</td>
            {scenarioQuestionTypesEnum.SelectMultiple !== scenarioQuestion.questionType && (
                <td>{enumLabel(questionOptions, nextQuestionId)}</td>
            )}
        </tr>
    );
};

export default ShowScenarioAnswerOption;
